<template>
  <div>
    <div style="display: flex; gap: 1rem">
      <div style="flex: 1">
        <p style="margin: 0; font-weight: 600">CAMPOS EMPRESA</p>

        <div>
          <p style="font-size: 0.7rem">
            @EMPRESA_NOME@, @EMPRESA_CNPJ@, @EMPRESA_ENDERECO@,
            @EMPRESA_NUMERO@, @EMPRESA_BAIRRO@, @EMPRESA_CIDADE@, @EMPRESA_UF@,
            @EMPRESA_CEP@, @EMPRESA_EMAIL@, @EMPRESA_CELULAR@
          </p>
        </div>
      </div>

      <div style="flex: 1">
        <p style="margin: 0; font-weight: 600">CAMPOS CLIENTE</p>

        <div>
          <p style="font-size: 0.7rem">
            @CLIENTE_NOME@, @CLIENTE_CPF_CNPJ@, @CLIENTE_ENDERECO@,
            @CLIENTE_BAIRRO@, @CLIENTE_NUMERO_END@ @CLIENTE_UF@,
            @CLIENTE_TELEFONE@, @CLIENTE_CELULAR@
          </p>
        </div>
      </div>
    </div>

    <div class="contrato-wrapper">
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 1rem;
        "
      >
        <p style="margin: 0; font-weight: 600">Pré-visualização do Contrato</p>

        <button class="btns" @click="saveOrUpdate">Salvar</button>
      </div>

      <div
        ref="refContract"
        class="folha-a4"
        contenteditable="true"
        v-html="defaultContract"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ServiceSettings from "../../services/serviceSettings";

export default {
  data() {
    return {
      defaultContract: "",
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ header: [1, 2, 3, false] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
          ],
        },
      },
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_CONFIG"]),
    async saveOrUpdate() {
      try {
        await ServiceSettings.updateContract({
          contract: this.$refs.refContract.innerHTML,
        });

        await this.getConfigAtm();
        this.$toast.success("Contrato atualizado!");
      } catch (error) {
        return this.$toast.info(
          error?.response?.data?.messa ||
            "Ocorreu um problema ao salvar o contrato editável"
        );
      }
    },
    async findContractEditableBaseString() {
      this.defaultContract =
        await ServiceSettings.findContractEditableBaseString();
    },
    async getConfigAtm() {
      try {
        let newAtm;
        const result = await ServiceSettings.findSettingsAtm();

        if (!result?.caixa_automatico) {
          newAtm = {
            idResponsavel: null,
            utilizar: false,
            valorInicial: 0.0,
            horaAbertura: null,
            horaFechamento: null,
          };
        } else {
          newAtm = result.caixa_automatico;
        }

        if (Object.keys(result).length) {
          return this.SET_DATA_CONFIG({
            ...result,
            id: result.id,
            caixa_automatico: newAtm,
          });
        }
      } catch (error) {
        console.log(error);
        return this.$toast.open({
          message: "Ocorreu um erro ao buscar informações do caixa",
          type: "info",
        });
      }
    },
  },
  mounted() {
    this.findContractEditableBaseString();
  },
};
</script>

<style scoped>
.contrato-wrapper {
  background: #eee;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.folha-a4 {
  background: white;
  /* width: 210mm; */
  /* min-height: 297mm; */
  /* padding: 20mm; */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  outline: none;
  cursor: text;
}

.folha-a4 >>> .generalContent {
  width: 100% !important;
}

.btns {
  border-radius: 5px;
  background-color: #0051a9;
  width: 165px;
  height: 30px;
  border: none;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>